import { render, staticRenderFns } from "./infoMess.vue?vue&type=template&id=15698fe0"
import script from "./infoMess.vue?vue&type=script&lang=js"
export * from "./infoMess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports